import {
  Component,
  AfterViewInit,
  Input,
  ViewChild,
  ElementRef,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  inject,
  ChangeDetectionStrategy
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { v4 as uuid } from 'uuid';
import { LottieFilesService } from '../../services/lottie-files.service';
import { NgStyle } from '@angular/common';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let lottie: any;

@Component({
  selector: 'importer-anim-icon',
  templateUrl: './anim-icon.component.html',
  styleUrls: ['./anim-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgStyle]
})
export class AnimIconComponent implements OnDestroy, AfterViewInit, OnChanges, OnDestroy {
  private readonly lottieFilesService = inject(LottieFilesService);
  private readonly destroy$ = inject<Subject<void>>(Subject) ?? new Subject<void>();

  @Input() svgIcon;
  @Input() animation;
  @Input() delay = 0;
  @Input() delayend = 0;
  @Input() loop = true;
  @Input() rotation = 0;
  @Input() autoplay = false;
  @Input() speed = 1;
  @Input() startFrame = 0;
  @Input() hoverAnimate = false;
  @Input() segment;
  @ViewChild('animsvg') animsvg: ElementRef;

  rndNum = uuid();

  ngOnDestroy(): void {
    lottie.destroy(this.rndNum);
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes.animation && changes.animation.currentValue === true) {
        setTimeout(() => {
          if (!this.segment) {
            lottie.play(this.rndNum);
          }
        }, this.delay);
      }
      if (changes.animation && changes.animation.currentValue === false) {
        setTimeout(() => {
          lottie.stop(this.rndNum);
          lottie.goToAndStop(this.startFrame, true, this.rndNum);
        }, this.delayend);
      }
    }
  }

  ngAfterViewInit(): void {
    const existingLSvg = this.lottieFilesService.getLottieFile(this.svgIcon);
    if (existingLSvg) {
      this.handleLottieContent(existingLSvg);
    } else {
      this.lottieFilesService
        .getLottieJson(this.svgIcon)
        .pipe(takeUntil(this.destroy$))
        .subscribe(lottieSvg => {
          this.lottieFilesService.setLottieFile(this.svgIcon, lottieSvg);
          this.handleLottieContent(lottieSvg);
        });
    }
  }

  handleLottieContent(file) {
    const anim = lottie.loadAnimation({
      container: this.animsvg.nativeElement, // the dom element that will contain the animation
      renderer: 'svg',
      loop: this.loop,
      autoplay: this.autoplay,
      name: this.rndNum,
      animationData: file
      // path: `assets/svgs/icon-data/${this.svgIcon}.json` // the path to the animation json
    });
    lottie.setSpeed(this.speed);
    if (this.segment) {
      setTimeout(() => {
        anim.playSegments(this.segment, false);
        setTimeout(() => {
          lottie.goToAndStop(this.segment[1], true, this.rndNum);
        }, 800);
      }, this.delay);
    } else {
      lottie.goToAndStop(this.startFrame, true, this.rndNum);
    }
    if (this.autoplay || this.animation) {
      lottie.play(this.rndNum);
    }
  }

  mEnter() {
    if (this.hoverAnimate) {
      lottie.play(this.rndNum);
    }
  }
  mLeave() {
    if (this.hoverAnimate) {
      lottie.stop(this.rndNum);
      if (this.startFrame) {
        lottie.goToAndStop(this.startFrame, true, this.rndNum);
      }
    }
  }
}
